module.exports = __webpack_public_path__ + "static/img/5.4a8caaa2.png";